import React from "react";
import { ArrowUpRight } from "lucide-react";

import { cn } from "@/shared/lib/cn";

/** A link that opens somewhere else in a new tab, its arrow after the words: an invoice at the
    payment provider, a chat app. */
export function ExternalLink({ className, children, ...rest }: Omit<React.ComponentPropsWithoutRef<"a">, "target" | "rel">) {
  return (
    <a
      target="_blank"
      rel="noreferrer"
      className={cn("press shrink-0 inline-flex items-center gap-0.5 text-[12.5px] text-[var(--text-secondary)] hover:text-[var(--text-primary)]", className)}
      {...rest}
    >
      {children}
      <ArrowUpRight aria-hidden="true" className="w-3 h-3" strokeWidth={1.75} />
    </a>
  );
}
